const plug = new Object();
import store from './../store'
import HttpsEncrypt from "@/http/indexencrypt";

/************************************************************
 *
 * 时分秒的判断
 *
 ************************************************************/
function formatTen(num) {
    return num > 9 ? num + "" : "0" + num;
}

plug.install = (Vue, options) => {
    Vue.mixin({
        components: {
            // 全局组件
            LayLeft: re => require(['@/components/MN/LayLeft'], re),//蒙
            LayRight: re => require(['@/components/MN/LayRight'], re),//蒙
            LayTop: re => require(['@/components/ZH/LayTop'], re),//中
            LayBottom: re => require(['@/components/ZH/LayBottom'], re),//中

            //蒙
            //书籍列表
            LayListBooks: re => require(['@/components/MN/LayListBooks'], re),
            //期刊列表
            LayListJournal: re => require(['@/components/MN/LayListJournal'], re),
            //报刊列表
            LayListNewspapers: re => require(['@/components/MN/LayListNewspapers'], re),
            //谚语、谜语、对联列表
            LayListChineseCulture: re => require(['@/components/MN/LayListChineseCulture'], re),
            //知识数据库
            LayQuestionBank: re => require(['@/components/MN/LayQuestionBank'], re),
            //作者列表
            LayAuthor: re => require(['@/components/MN/LayAuthor'], re),
            //目录数据库列表
            LayCatalogDatabase: re => require(['@/components/MN/LayCatalogDatabase'], re),
            //详情页的左侧边
            DetailaLeft: re => require(['@/components/MN/DetailaLeft'], re),
            //歌列表
            LaySongList: re => require(['@/components/MN/LaySongList'], re),
            //全部期刊列表
            LayAllJournalList: re => require(['@/components/MN/LayAllJournalList'], re),
            //视频
            LayListVideo: re => require(['@/components/MN/LayListVideo'], re),
            //杂志期刊树状
            LayPeriodicalJournal: re => require(['@/components/MN/LayPeriodicalJournal'], re),
            //词典翻译
            LayTranslate: re => require(['@/components/MN/LayTranslate'], re),
            //智能翻译
            LayIntarTranslate: re => require(['@/components/MN/LayIntarTranslate'], re),
            //分页
            PageMn: re => require(['@/components/MN/PageMn.vue'], re),

            //中
            //书籍列表
            LayListBooksZh: re => require(['@/components/ZH/LayListBooks'], re),
            //智能翻译
            LayIntarTranslateZh: re => require(['@/components/ZH/LayIntarTranslateZh'], re),

            //pdf查看
            file_preview: re => require(['@/components/Common/file_preview'], re),
            //返回键
            goback: re => require(['@/components/MN/goback'], re),
            //全局音频播放器
            bgMusic: re => require(['@/components/Common/bgMusic'], re),
            //侧边栏
            AqtSidebarMn: re => require(['@/components/Common/AqtSidebarMn'], re),
            AqtSidebarZh: re => require(['@/components/Common/AqtSidebarZh'], re),
            //加载动画
            AqtSpin: re => require(['@/components/Common/AqtSpin'], re),


        },
        computed: {},
        mounted() {
        }

    })
    // 注册转码过滤器 U2M
    Vue.filter('U2M', function (value) {
        if (value) {
            return Unicode2M(value);
        } else {
            return value
        }

    })
    // 注册转码过滤器 M2U
    Vue.filter('M2U', function (value) {
        if (value) {
            return M2Unicode(value);
        } else {
            return value
        }

    })
    Vue.prototype.U2M = function (value) {
        //changeData是函数名
        if (value) {
            var filetered = Unicode2M(value);
        } else {
            var filetered = value;
        }
        return filetered;
    }
    Vue.prototype.M2U = function (value) {
        //changeData是函数名
        if (value) {
            var filetered = M2Unicode(value);
        } else {
            var filetered = value;
        }
        return filetered;
    }
    /********************************************************
     * 返回到列表时，距离上边位置
     **********************************************************/
    Vue.prototype.$getScrollTopCommon = function (element) {
        if (element === window) {
            return Math.max(
                window.pageXOffset || 0,
                document.documentElement.scrollTop
            );
        }
        return element.scrollTop;
    }
    /********************************************************
     * 返回到列表时，距离左边的位置
     **********************************************************/
    Vue.prototype.$getScrollLeftCommon = function (element) {
        if (element === window) {
            return Math.max(
                window.pageXOffset || 0,
                document.documentElement.scrollLeft
            );
        }
        return element.scrollLeft;
    }
    /*****************************************************************
     * 音视频文件大小转换
     *****************************************************************/
    Vue.prototype.$fileSizeTransformation = function (value) {
        let size = "0B";
        if (value > 0) {
            if (value < 0.1 * 1024) {
                //小于0.1KB，则转化成B
                size = value.toFixed(2) + "B";
            } else if (value < 0.1 * 1024 * 1024) {
                //小于0.1MB，则转化成KB
                size = (value / 1024).toFixed(2) + "KB";
            } else if (value < 0.1 * 1024 * 1024 * 1024) {
                //小于0.1GB，则转化成MB
                size = (value / (1024 * 1024)).toFixed(2) + "MB";
            } else {
                //其他转化成GB
                size = (value / (1024 * 1024 * 1024)).toFixed(2) + "GB";
            }
        }
        return size;
    }
    /************************************************************
     * 文字高亮
     ************************************************************/
    Vue.prototype.$dataLight = function (str, lang, key) {
        if (lang == 'mn') {
            let arr = str.split(" ");
            let strarr = key.split(" ");

            arr.forEach((elem, index) => {
                strarr.forEach((it) => {
                    if (!it) {
                        return str;
                    }
                    let i = elem.indexOf(it.trim());
                    if (i > -1) {
                        let replacestr = `<span style="color:var(--themeColor)!important;">${arr[index]}</span>`
                        arr[index] = replacestr;
                    }
                });

            });

            str = arr.join(" ");
        }
        if (lang == 'zh') {
            if (!str) {
                return str;
            }
            let search = new RegExp(key, 'g');
            let replacestr = `<span style="color:var(--themeColor)!important;">${key}</span>`
            str = str.replace(search, replacestr);
        }
        return str;
    },
        //去掉文件后缀名
        Vue.prototype.$DeleteFileName = function (value) {
            if (value) {
                const noExtension = value.replace(/(.*)\.[^.]+$/, "$1")
                return noExtension
            }
        }
    //将文本中的所有\n’转换成<br>
    Vue.prototype.$TextConversion = function (text) {
        return text.replace(/\n/g, '<br>');
    }
    Vue.prototype.$getNowTime = function () {
        let dateTime = ''
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        dateTime = year + "-" + formatTen(month) + "-" + formatTen(day) + " " + formatTen(hour) + ":" + formatTen(minute) + ":" + formatTen(second)
        return dateTime
    }

    /*****************************************************************
     *
     * 资源请求接口
     * model：模块类型 Book书籍 QiKan期刊/杂志 BookMuLu书籍目录 QiKanMuLu期刊目录
     *        NewsPaperMuLu报刊目录 Paper论文 NewsPaperLayout报刊版面 NewsPapeOoffice报社
     *        VideoCategory视频分类 Videos视频 Painting画 ReadBook书的精读 SpeakBook书的精讲
     *        ListenBook阿启泰听书 AudioRes：ources有声资源 Song歌 AudioResourcesSoundtrack有声资源背景音乐
     *
     *
     * filetype：文件类型 File文件 Image图片 Video视频 Audio音频
     * quality：文件种类 Original原图(普清) Thumb压缩(普通)
     * level：安全等级AQT_2023_1 、AQT_2023_2 、AQT_2023_3
     * type1: 书籍目录传55 期刊目录传44 报刊目录传56 论文传54 书籍目录文字内容传59 期刊目录文字内容传58 报刊目录文字内容60
     *        书籍、期刊详情中pdf请求和多图使用的是路由上的type
     *
     *****************************************************************/

    Vue.prototype.$getResources = function (info) {
        return new Promise((resolve, reject) => {
            //检查定位是否授权  authorized 已开启定位权限 denied 已关闭定位权限
            // undetermined 未确定定位权限 unk

            let cond = {
                terminal: Vue.prototype.$terminal,//终端类型
                model: info.model ? info.model : '',//模块
                filetype: info.filetype ? info.filetype : '',//文件类型
                quality: 'Original',//文件种类
                level: info.level ? info.level : '',//安全等级
                library_id: localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : "",
                lang: info.lang ? info.lang : 'mn',
                id: info.id ? info.id : '',//主键id
                isshowpdf: info.isshowpdf ? info.isshowpdf : 2,////是否可以查看pdf 1是 2否
                ztisfree: info.ztisfree ? info.ztisfree : 2,//专题是否收费 1免费  2收费
                priceclass_id: info.priceclass_id ? info.priceclass_id : '',//专题id
                menu_id: '',//菜单id
                member_id: localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : '',
                wificode: store.getters.wificode,//Wi-Fi码
                network: store.getters.network,//网络

                appterminallx: '',//终端具体类型和软件的版本号
                latlon: store.getters.latlon,// 经纬度
                devicecode: store.getters.uuid,//设备码,

                type1: info.type1 ? info.type1 : '',//app中用户行为记录时传的值
                path: Vm.$route.path,
                name: info.name ? info.name : '',//用户浏览记录的标识
                ls: 'news'
            }
            HttpsEncrypt.post('api/web/v3/resources/resourcesdata', cond).then(val => {
                if (val && val.code == 200) {
                    resolve(val)
                } else {
                    Vue.prototype.$Message.warning({
                        content: val.message
                    })
                }

            }).catch(err => {
                resolve(err)
            })


        })
    }


}
export default plug
